import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { StatusCodes } from "http-status-codes"
import ResponseError from "types/responseError"
import buildCarrotApiRetryPolicy from "utils/CarrotApiRetryPolicy"
import { getExpertBios } from "../lib/ExpertBioClient"
import { ExpertBio, mapContentToExpertBio } from "components/read/shared/ExpertBioMapper"

type QueryResponse = ExpertBio[]

export default function useGetExpertBios(locale: string): UseQueryResult<QueryResponse, ResponseError> {
  return useQuery<QueryResponse, ResponseError>(
    ["Contentful Expert Bios"],
    async () => {
      try {
        const res = await getExpertBios(locale)
        return res ? res.map(mapContentToExpertBio) : []
      } catch (error) {
        if (error.statusCode === StatusCodes.NOT_FOUND) {
          return []
        }
        throw error
      }
    },
    {
      refetchOnWindowFocus: false,
      retry: buildCarrotApiRetryPolicy(3)
    }
  )
}
